import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronUp, ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react';
import { getOrders, getCachedOrders, cacheOrders, subscribeToOrders, markOrderAsDelivered } from '../utils/orders';
import { getCachedUser } from '../utils/auth';
import { useTranslation } from '../hooks/useTranslation';
import { showToast } from './ToastContainer';
import { Skeleton } from './common/Skeleton';
import { getOrderHref, isBoostingOrder } from '../utils/orderLinks';
import '../styles/BuyerOrders.css';

const getGameIcon = (gameName) => {
  if (!gameName) return null;
  
  const iconMap = {
    'Fortnite': 'Fortnite.png',
    'Counter Strike 2': 'CS2.png',
    'Roblox': 'Roblox.png',
    'Valorant': 'Valorant.png',
    'Warcraft': 'Worldofwarcraft.png',
    'Clash Royale': 'Clashroyale.png',
    'Apex Legends': 'ApexLegends.png',
    'Arc Raiders': 'ARcraiders.png',
    'COD Call of Duty': 'Callofduty.png',
    'Call of Duty': 'Callofduty.png',
    'EA Sports FC': 'EAsports.png',
    'Escape from Tarkov': 'Escapefromtarkov.png',
    'League of Legends': 'Leagueoflegends.png',
    'Old School RuneScape': 'Oldschoolrunescape.png',
    'Rainbow Six Siege': 'Rainbowsix.png',
    'Rocket League': 'rocketleague.png',
    'DonutSMP': 'donutsmp.jpg',
    'Hypixel': 'hypixel.jpg',
  };
  
  if (gameName === 'DonutSMP') {
    return '/main/games/icons/donutsmp.jpg';
  }
  if (gameName === 'Hypixel') {
    return '/main/games/icons/hypixel.jpg';
  }
  if (gameName === 'Counter Strike 2') {
    return '/main/games/icons/cs2.png';
  }
  if (gameName === '8 Ball Pool') {
    return '/main/games/icons/8bp.webp';
  }
  if (gameName === 'Kaiju No. 8') {
    return '/main/games/icons/kaiju8.jpg';
  }
  if (gameName === '99 Nights in the Forest') {
    return '/main/games/icons/99nitf.webp';
  }
  if (gameName === 'Adopt Me') {
    return '/main/games/icons/adoptme.jpeg';
  }
  if (gameName === 'Albion Online') {
    return '/main/games/icons/alibiononline.webp';
  }
  if (gameName === 'All Star Tower Defense X') {
    return '/main/games/icons/allstartowerdefense.jpeg';
  }
  if (gameName === 'Animal Crossing: New Horizons') {
    return '/main/games/icons/animalcrossing.jpg';
  }
  if (gameName === 'Anime Defenders') {
    return '/main/games/icons/animedefenders.webp';
  }
  if (gameName === 'Anime Vanguards') {
    return '/main/games/icons/animevanguards.jpg';
  }
  if (gameName === 'ARK: Survival Ascended') {
    return '/main/games/icons/arksurvivalascended.webp';
  }
  if (gameName === 'Arknights') {
    return '/main/games/icons/Arknights.png';
  }
  if (gameName === 'Ayakashi Rumble!') {
    return '/main/games/icons/AyakashiRumble.webp';
  }
  if (gameName === 'Battlenet') {
    return '/main/games/icons/battlenet.jpg';
  }
  if (gameName === 'Arena Breakout') {
    return '/main/games/icons/arenabreakout1.jpg';
  }
  if (gameName === 'Arena Breakout: Infinite') {
    return '/main/games/icons/arenabreakout.jpg';
  }
  if (gameName === 'Black Clover M') {
    return '/main/games/icons/Blackclover.jpeg';
  }
  if (gameName === 'Black Desert Online') {
    return '/main/games/icons/blackdessertonline.png';
  }
  if (gameName === 'Bleach: Brave Souls') {
    return '/main/games/icons/Bleachbravesouls.webp';
  }
  if (gameName === 'Blood Strike') {
    return '/main/games/icons/bloodstrike.webp';
  }
  if (gameName === 'Blox Fruits') {
    return '/main/games/icons/bloxfruits.jpg';
  }
  if (gameName === 'Brawl Stars') {
    return '/main/games/icons/brawl-stars.webp';
  }
  if (gameName === 'Call of Duty Mobile') {
    return '/main/games/icons/codmobile.webp';
  }
  if (gameName === 'Car Parking Multiplayer') {
    return '/main/games/icons/carparkingmultiplayer.webp';
  }
  if (gameName === 'Chaos Zero Nightmare') {
    return '/main/games/icons/choaszero.webp';
  }
  if (gameName === 'Chocotto Land') {
    return '/main/games/icons/chocottoland.jpg';
  }
  if (gameName === 'Clash of Clans') {
    return '/main/games/icons/clashofclans.jpg';
  }
  if (gameName === 'Cookie Run: Kingdom') {
    return '/main/games/icons/cookierunkingdom.webp';
  }
  if (gameName === 'Crunchyroll') {
    return '/main/games/icons/crunchyroll.jpg';
  }
  if (gameName === 'Dark and Darker') {
    return '/main/games/icons/darkanddarker.jpg';
  }
  if (gameName === 'DarkOrbit') {
    return '/main/games/icons/darkorbit.jpg';
  }
  if (gameName === 'DayZ') {
    return '/main/games/icons/dayz.avif';
  }
  if (gameName === 'Dead By Daylight') {
    return '/main/games/icons/deadbydaylight.jpg';
  }
  if (gameName === 'Dead Rails') {
    return '/main/games/icons/deadrails.jpg';
  }
  if (gameName === 'Delta Force') {
    return '/main/games/icons/deltaforce.jpeg';
  }
  if (gameName === 'Destiny 2') {
    return '/main/games/icons/destiny2.jpeg';
  }
  if (gameName === 'Diablo 4') {
    return '/main/games/icons/diablo4.avif';
  }
  if (gameName === 'Diablo Immortal') {
    return '/main/games/icons/diabloimortal.jpg';
  }
  if (gameName === 'Digimon Super Rumble') {
    return '/main/games/icons/digimonsuperrumble.jpg';
  }
  if (gameName === 'Discord') {
    return '/main/games/icons/discord.jpg';
  }
  if (gameName === 'Dota 2') {
    return '/main/games/icons/dota2.jpg';
  }
  if (gameName === 'Dragon Ball Legends') {
    return '/main/games/icons/dragonballlegends.jpg';
  }
  if (gameName === 'Dragon Ball Z Dokkan Battle') {
    return '/main/games/icons/DragonBallZDokkanBattle.jpg';
  }
  if (gameName === 'Duet Night Abyss') {
    return '/main/games/icons/duetnightabyss.jpg';
  }
  if (gameName === 'EA Sports FC Mobile') {
    return '/main/games/icons/eafcmobile.jpg';
  }
  if (gameName === 'eFootball') {
    return '/main/games/icons/efotball.jpg';
  }
  if (gameName === 'Elden Ring') {
    return '/main/games/icons/eldenring.jpg';
  }
  if (gameName === 'Elder Scrolls Online') {
    return '/main/games/icons/elderscrollsonline.jpg';
  }
  if (gameName === 'Epic Games') {
    return '/main/games/icons/epicgames.jpg';
  }
  if (gameName === 'Epic Seven') {
    return '/main/games/icons/epicseven.jpg';
  }
  if (gameName === 'Etheria: Restart') {
    return '/main/games/icons/etheriarestart.jpg';
  }
  if (gameName === 'Fallout 76') {
    return '/main/games/icons/fallout76.jpg';
  }
  if (gameName === 'Fate/Grand Order') {
    return '/main/games/icons/fategrandorder.jpg';
  }
  if (gameName === 'Final Fantasy XIV') {
    return '/main/games/icons/finalfantasyxix.jpg';
  }
  if (gameName === 'Fisch') {
    return '/main/games/icons/fisch.jpg';
  }
  if (gameName === 'Forza Horizon 5') {
    return '/main/games/icons/forzahorizon5.jpg';
  }
  if (gameName === 'Garena Free Fire') {
    return '/main/games/icons/garenafreefire.jpeg';
  }
  if (gameName === 'Genshin Impact') {
    return '/main/games/icons/genshinimpact.avif';
  }
  if (gameName === 'Girls Frontline 2: Exilium') {
    return '/main/games/icons/girlsfrontline2exilium.jpg';
  }
  if (gameName === 'Golden HoYeah') {
    return '/main/games/icons/goldenhoyeah.png';
  }
  if (gameName === 'Granblue Fantasy') {
    return '/main/games/icons/granbluefantasy.webp';
  }
  if (gameName === 'Grand Roleplay') {
    return '/main/games/icons/grandrp.jpg';
  }
  if (gameName === 'Grand Theft Auto 5') {
    return '/main/games/icons/grandtheftauto.jpg';
  }
  if (gameName === 'Grow a Garden') {
    return '/main/games/icons/growagarden.jpg';
  }
  if (gameName === 'Hay Day') {
    return '/main/games/icons/hayday.jpg';
  }
  if (gameName === 'Honkai Impact 3rd') {
    return '/main/games/icons/honkaimpact3rd.jpg';
  }
  if (gameName === 'Honkai: Star Rail') {
    return '/main/games/icons/honkaistarrail.jpg';
  }
  if (gameName === 'Houchi Shoujo') {
    return '/main/games/icons/houchishouju.jpeg';
  }
  if (gameName === 'Identity V') {
    return '/main/games/icons/identityv.jpg';
  }
  if (gameName === 'Jailbreak') {
    return '/main/games/icons/jailbreak.webp';
  }
  if (gameName === "JoJo's Bizarre Adventure: Ora Ora Overdrive") {
    return '/main/games/icons/jojoOraOra.webp';
  }
  if (gameName === 'Jujutsu Infinite') {
    return '/main/games/icons/jujutsuinfinite.jpeg';
  }
  if (gameName === 'Jujutsu Kaisen Phantom Parade') {
    return '/main/games/icons/JujutsuKaisenPhantomParade.jpeg';
  }
  if (gameName === 'King Legacy') {
    return '/main/games/icons/kinglegacy.jpg';
  }
  if (gameName === 'Knight Online') {
    return '/main/games/icons/knightonline.jpg';
  }
  if (gameName === 'Knives Out') {
    return '/main/games/icons/knivesout.jpg';
  }
  if (gameName === 'Last Island of Survival') {
    return '/main/games/icons/lastislandofsurvival.avif';
  }
  if (gameName === 'Last War: Survival') {
    return '/main/games/icons/lastwarsurvival.jpg';
  }
  if (gameName === 'League of Legends') {
    return '/main/games/icons/leagueoflegends.jpg';
  }
  if (gameName === 'League of Legends: Wild Rift') {
    return '/main/games/icons/leagueoflegendswildrift.jpg';
  }
  if (gameName === 'Livly Island') {
    return '/main/games/icons/livlyisland.png';
  }
  if (gameName === 'Lords Mobile') {
    return '/main/games/icons/lordsmobile.jpg';
  }
  if (gameName === 'Lost Ark') {
    return '/main/games/icons/lostark.jpg';
  }
  if (gameName === 'Madoka Magica Magia Exedra') {
    return '/main/games/icons/MadokaMagicaMagiaExedra.jpg';
  }
  if (gameName === 'Marvel Contest of Champions') {
    return '/main/games/icons/marvelcontestofchampions.jpg';
  }
  if (gameName === 'Marvel Rivals') {
    return '/main/games/icons/marvelrivals.jpg';
  }
  if (gameName === 'Metin2') {
    return '/main/games/icons/metin2.jpg';
  }
  if (gameName === 'Millennium War Aigis') {
    return '/main/games/icons/MillenniumWarAigis.webp';
  }
  if (gameName === 'Mobile Legends') {
    return '/main/games/icons/mobilelegends.webp';
  }
  if (gameName === 'Monster Hunter Now') {
    return '/main/games/icons/MonsterHunterNow.jpeg';
  }
  if (gameName === 'Monster Strike') {
    return '/main/games/icons/monsterstrike.jpg';
  }
  if (gameName === 'Netflix') {
    return '/main/games/icons/netflix.jpg';
  }
  if (gameName === 'New World') {
    return '/main/games/icons/newworld.jpg';
  }
  if (gameName === 'One Piece Bounty Rush') {
    return '/main/games/icons/OnePieceBountyRush.jpg';
  }
  if (gameName === 'One Piece Treasure Cruise') {
    return '/main/games/icons/OnePieceTreasureCruise.jpg';
  }
  if (gameName === 'Origin') {
    return '/main/games/icons/orgin.jpg';
  }
  if (gameName === 'Overwatch 2') {
    return '/main/games/icons/overwatch2.jpg';
  }
  if (gameName === 'Path of Exile') {
    return '/main/games/icons/pathofexile.jpg';
  }
  if (gameName === 'Path of Exile 2') {
    return '/main/games/icons/pathofexile2.webp';
  }
  if (gameName === 'Persona 5: The Phantom X') {
    return '/main/games/icons/Persona5ThePhantomX.jpg';
  }
  if (gameName === 'Plants vs Brainrots') {
    return '/main/games/icons/PlantsvsBrainrots.jpg';
  }
  if (gameName === 'PlayStation') {
    return '/main/games/icons/playstation.jpg';
  }
  if (gameName === 'Pokecolo') {
    return '/main/games/icons/pokecolo.jpg';
  }
  if (gameName === 'Pokecolo Twin') {
    return '/main/games/icons/pokecolotwin.jpg';
  }
  if (gameName === 'Pokemon Go') {
    return '/main/games/icons/pokemongo.jpg';
  }
  if (gameName === 'Pokemon TCG Pocket') {
    return '/main/games/icons/pokemontcgpocket.jpg';
  }
  if (gameName === 'Princess Connect! Re:Dive') {
    return '/main/games/icons/PrincessConnectRe-Dive.png';
  }
  if (gameName === 'Professional Baseball Spirits A') {
    return '/main/games/icons/ProfessionalBaseballSpiritsA.jpg';
  }
  if (gameName === 'Project SEKAI') {
    return '/main/games/icons/projectsekai.webp';
  }
  if (gameName === 'PUBG') {
    return '/main/games/icons/pubg.jpg';
  }
  if (gameName === 'PUBG Mobile') {
    return '/main/games/icons/pubgmobile.jpg';
  }
  if (gameName === 'Puzzle and Dragons') {
    return '/main/games/icons/PuzzleandDragons.webp';
  }
  if (gameName === 'Raid: Shadow Legends') {
    return '/main/games/icons/raidshadowlegends.jpg';
  }
  if (gameName === 'Rainbow Six Siege X') {
    return '/main/games/icons/RainbowSixSiegeX.jpg';
  }
  if (gameName === 'Rise of Kingdoms') {
    return '/main/games/icons/RiseofKingdoms.jpg';
  }
  if (gameName === 'Rocket League') {
    return '/main/games/icons/rocketleague.jpg';
  }
  if (gameName === 'Royale Online') {
    return '/main/games/icons/royaleonline.jpg';
  }
  if (gameName === 'RuneScape 3') {
    return '/main/games/icons/runescape3.jpg';
  }
  if (gameName === 'Rust') {
    return '/main/games/icons/rust.png';
  }
  if (gameName === 'SD Gundam G Generation ETERNAL') {
    return '/main/games/icons/eternal.webp';
  }
  if (gameName === 'Sea of Thieves') {
    return '/main/games/icons/seaofthieves.jpg';
  }
  if (gameName === 'Seven Knights Re:BIRTH') {
    return '/main/games/icons/SevenKnightsReBIRTH.jpg';
  }
  if (gameName === 'Shadowverse') {
    return '/main/games/icons/shadowverse.jpg';
  }
  if (gameName === 'Silver and Blood') {
    return '/main/games/icons/silverandblood.webp';
  }
  if (gameName === 'Sky: Children of the Light') {
    return '/main/games/icons/SkyChildrenoftheLight.jpg';
  }
  if (gameName === 'Spotify') {
    return '/main/games/icons/spotify.jpg';
  }
  if (gameName === 'Standoff 2') {
    return '/main/games/icons/standoff2.jpg';
  }
  if (gameName === 'Steal a Brainrot') {
    return '/main/games/icons/stealabrainrot.jpg';
  }
  if (gameName === 'Stella Sora') {
    return '/main/games/icons/stellasora.jpg';
  }
  if (gameName === 'Summoners War') {
    return '/main/games/icons/SummonersWar.jpg';
  }
  if (gameName === 'The Finals') {
    return '/main/games/icons/thefinals.jpg';
  }
  if (gameName === 'The Forge') {
    return '/main/games/icons/theforge.jpg';
  }
  if (gameName === 'The Seven Deadly Sins') {
    return '/main/games/icons/thesevendeadlysins.jpg';
  }
  if (gameName === 'Throne and Liberty') {
    return '/main/games/icons/ThroneandLiberty.jpg';
  }
  if (gameName === 'Tower of Fantasy') {
    return '/main/games/icons/toweroffantasy.jpg';
  }
  if (gameName === 'Ubisoft Connect') {
    return '/main/games/icons/ubisoftconnect.jpeg';
  }
  if (gameName === 'Uma Musume Pretty Derby') {
    return '/main/games/icons/UmaMusumePrettyDerby.jpg';
  }
  if (gameName === 'unVEIL the world') {
    return '/main/games/icons/unVEILtheworld.jpeg';
  }
  if (gameName === 'Volleyball Legends') {
    return '/main/games/icons/volleyballlegends.webp';
  }
  if (gameName === 'War Thunder') {
    return '/main/games/icons/warthunder.jpg';
  }
  if (gameName === 'Warframe') {
    return '/main/games/icons/warframe.jpg';
  }
  if (gameName === 'Wartune Ultra') {
    return '/main/games/icons/wartuneultra.png';
  }
  if (gameName === 'Watcher of Realms') {
    return '/main/games/icons/watcherofrealms.jpg';
  }
  if (gameName === 'Where Winds Meet') {
    return '/main/games/icons/WhereWindsMeet.jpg';
  }
  if (gameName === 'White Cat Project') {
    return '/main/games/icons/WhiteCatProject.jpg';
  }
  if (gameName === 'Whiteout Survival') {
    return '/main/games/icons/whiteoutsurvial.jpg';
  }
  if (gameName === 'WolfTeam') {
    return '/main/games/icons/wolfteam.jpg';
  }
  if (gameName === 'World of Tanks') {
    return '/main/games/icons/worldoftanks.jpg';
  }
  if (gameName === 'World of Warcraft') {
    return '/main/games/icons/worldofwarcraft.jpg';
  }
  if (gameName === 'World of Warships') {
    return '/main/games/icons/worldofwarships.jpg';
  }
  if (gameName === 'WoW Classic') {
    return '/main/games/icons/wowclassic.jpg';
  }
  if (gameName === 'WoW Mists of Pandaria') {
    return '/main/games/icons/WoWMistsofPandaria.jpg';
  }
  if (gameName === 'Wuthering Waves') {
    return '/main/games/icons/WutheringWaves.jpg';
  }
  if (gameName === 'Xbox') {
    return '/main/games/icons/xbox.jpg';
  }
  if (gameName === 'Yo-kai Watch: Wibble Wobble') {
    return '/main/games/icons/YokaiWatchWibbleWobble.jpg';
  }
  if (gameName === 'Yu-Gi-Oh! Master Duel') {
    return '/main/games/icons/Yu-Gi-OhMasterDuel.jpg';
  }
  if (gameName === 'Zenless Zone Zero') {
    return '/main/games/icons/ZenlessZoneZero.jpg';
  }
  if (gameName === 'Zula') {
    return '/main/games/icons/zula.jpeg';
  }
  if (gameName === 'Goddess of Victory: Nikke') {
    return '/main/games/icons/nikke.jpg';
  }
  
  return iconMap[gameName] ? `/main/hero section/promos/navbaricons/${iconMap[gameName]}` : null;
};

const getGameNameFromSlug = (gameSlug) => {
  const gameNameMap = {
    'fortnite': 'Fortnite',
    'counter-strike-2': 'Counter Strike 2',
    'roblox': 'Roblox',
    'valorant': 'Valorant',
    'warcraft': 'Warcraft',
    'clash-royale': 'Clash Royale',
    'anime-vanguards': 'Anime Vanguards',
    'apex-legends': 'Apex Legends',
    'arc-raiders': 'Arc Raiders',
    'arena-breakout': 'Arena Breakout',
    'arena-breakout-infinite': 'Arena Breakout: Infinite',
    'battlefield': 'Battlefield',
    'cod-call-of-duty': 'COD Call of Duty',
    'escape-from-tarkov': 'Escape from Tarkov',
    'ea-sports-fc': 'EA Sports FC',
    'league-of-legends': 'League of Legends',
    'old-school-runescape': 'Old School RuneScape',
    'rainbow-six-siege': 'Rainbow Six Siege',
    'rocket-league': 'Rocket League',
  };
  return gameNameMap[gameSlug] || gameSlug;
};

const SellerOrders = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const prefetchOrderDetail = () => {
    // Preload the lazy chunk so navigation feels instant
    import('../pages/OrderDetailPage').catch(() => {});
  };
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState('all');
  const [dateFilter, setDateFilter] = useState('recent');
  const [currentPage, setCurrentPage] = useState(1);
  const [sortColumn, setSortColumn] = useState(null); // null means use dateFilter, otherwise use column sort
  const [sortDirection, setSortDirection] = useState('asc');
  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const [dateDropdownOpen, setDateDropdownOpen] = useState(false);
  const [markingDelivered, setMarkingDelivered] = useState(() => new Set());
  const itemsPerPage = 10;

  const filterOrders = (ordersList) => {
    let filtered = ordersList || [];
    
    if (statusFilter !== 'all') {
      if (statusFilter === 'pending') {
        // Show orders that are pending payment OR paid but in escrow (waiting for buyer to accept)
        filtered = filtered.filter(o => 
          o.status === 'pending' || 
          o.escrow_status === 'pending' || 
          o.escrow_status === 'paid' // Paid orders in escrow - seller can see these
        );
      } else if (statusFilter === 'completed') {
        // Show orders that are completed (escrow released or status completed)
        filtered = filtered.filter(o => o.escrow_status === 'released' || o.status === 'completed');
      }
    }
    
    // Don't sort here - sorting is handled by sortedOrders
    return filtered;
  };
  
  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };
  
  const sortedOrders = [...orders].sort((a, b) => {
    if (sortColumn === 'order_name') {
      const nameA = (a.metadata?.ad_title || '').toLowerCase();
      const nameB = (b.metadata?.ad_title || '').toLowerCase();
      const nameResult = sortDirection === 'asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
      // If names are equal, sort by date as secondary sort
      if (nameResult === 0) {
        const dateA = new Date(a.created_at);
        const dateB = new Date(b.created_at);
        return dateFilter === 'recent' ? dateB - dateA : dateA - dateB;
      }
      return nameResult;
    } else if (sortColumn === 'ordered_date') {
      // When user clicks date column, use sortDirection
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    } else {
      // Default: sort by dateFilter (recent = newest first, oldest = oldest first)
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return dateFilter === 'recent' ? dateB - dateA : dateA - dateB;
    }
  });
  
  const totalPages = Math.ceil(sortedOrders.length / itemsPerPage);
  const paginatedOrders = sortedOrders.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Close dropdowns when clicking outside (defer so the opening click is never counted as "outside")
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.orders-filter-dropdown')) {
        setStatusDropdownOpen(false);
        setDateDropdownOpen(false);
      }
    };

    let timeoutId;
    if (statusDropdownOpen || dateDropdownOpen) {
      timeoutId = window.setTimeout(() => {
        document.addEventListener('click', handleClickOutside);
      }, 0);
    }

    return () => {
      window.clearTimeout(timeoutId);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [statusDropdownOpen, dateDropdownOpen]);

  useEffect(() => {
    // Load from cache immediately for instant display
    const cached = getCachedOrders('seller');
    if (cached && cached.length > 0) {
      setOrders(filterOrders(cached));
      setLoading(false);
    } else {
      setLoading(true);
    }

    // Then load fresh data
    loadOrders();

    // Subscribe to real-time order updates
    const user = getCachedUser();
    if (user?.id) {
      const unsubscribe = subscribeToOrders(user.id, (payload) => {
        console.log('Order update received:', payload);
        // Reload orders when they change
        loadOrders(false); // Don't use cache, get fresh data
      });

      return () => {
        unsubscribe();
      };
    }
  }, [statusFilter, dateFilter]);

  const loadOrders = async (useCache = true) => {
    if (!useCache) {
      setLoading(true);
    }
    try {
      const data = await getOrders('seller', useCache);
      // Parse metadata if it's a string (Supabase should do this automatically, but adding safeguard)
      const ordersWithParsedMetadata = (data.data || []).map(order => {
        if (order.metadata && typeof order.metadata === 'string') {
          try {
            order.metadata = JSON.parse(order.metadata);
          } catch (e) {
            console.error('Failed to parse order metadata:', e);
          }
        }
        return order;
      });
      
      const filtered = filterOrders(ordersWithParsedMetadata);
      setOrders(filtered);
      // Update cache
      if (data.data) {
        cacheOrders('seller', ordersWithParsedMetadata);
      }
    } catch (error) {
      console.error('Failed to load orders:', error);
      if (!useCache) {
        showToast('Failed to load orders', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  };

  const getStatusBadge = (order) => {
    const status = order.status || 'pending';
    const escrowStatus = order.escrow_status || 'pending';
    
    // Check for canceled status
    if (status === 'canceled' || escrowStatus === 'refunded') {
      return <span className="order-status-badge canceled">Canceled</span>;
    }
    
    if (escrowStatus === 'released' || status === 'completed') {
      return <span className="order-status-badge completed">Completed</span>;
    }
    
    // Paid and in escrow - waiting for buyer to accept
    if (escrowStatus === 'paid' && status === 'paid') {
      return <span className="order-status-badge paid-escrow">Paid (In Escrow)</span>;
    }
    
    // Seller marked as delivered - waiting for buyer to mark as received
    if (order.seller_marked_delivered || order.delivered_at) {
      return <span className="order-status-badge pending-delivery">{t('dashboard.pendingDelivery')}</span>;
    }
    
    // Pending payment
    if (escrowStatus === 'pending' || status === 'pending') {
      return <span className="order-status-badge pending">Pending Payment</span>;
    }
    
    // Default
    return <span className="order-status-badge pending">Pending</span>;
  };
  
  const getOrderType = (order) => {
    if (order.metadata?.type === 'boosting') return 'Boosting';
    if (order.metadata?.service_type === 'accounts') return 'Accounts';
    if (order.metadata?.service_type === 'top-ups') return 'Top Ups';
    if (order.metadata?.service_type === 'items') return 'Items';
    return order.metadata?.service_type || 'N/A';
  };
  
  const getGameName = (order) => {
    if (order.metadata?.game) {
      return getGameNameFromSlug(order.metadata.game);
    }
    return 'N/A';
  };

  const handleMarkDelivered = async (e, orderId) => {
    e.stopPropagation(); // Prevent row click navigation
    if (markingDelivered.has(orderId)) return;
    
    setMarkingDelivered(prev => new Set(prev).add(orderId));
    try {
      await markOrderAsDelivered(orderId);
      showToast('Order marked as delivered', 'success');
      // Reload orders
      loadOrders(false);
    } catch (error) {
      showToast(error.message || 'Failed to mark order as delivered', 'error');
    } finally {
      setMarkingDelivered(prev => {
        const next = new Set(prev);
        next.delete(orderId);
        return next;
      });
    }
  };

  const canMarkDelivered = (order) => {
    // Can mark as delivered if: paid and in escrow, but not yet marked as delivered
    return order.escrow_status === 'paid' && 
           order.status === 'paid' && 
           !order.seller_marked_delivered;
  };

  // Only show skeleton if loading and no cached data
  const showSkeleton = loading && orders.length === 0;

  const openOrder = (order) => {
    const href = getOrderHref(order);
    if (!href) return;
    if (!isBoostingOrder(order)) prefetchOrderDetail();
    navigate(href);
  };

  if (showSkeleton) {
    return (
      <div className="buyer-orders-container">
        <div className="buyer-orders-toolbar">
          <Skeleton width="120px" height="34px" style={{ borderRadius: '4px' }} />
          <Skeleton width="100px" height="34px" style={{ borderRadius: '4px' }} />
        </div>
        <div className="orders-table-shell">
          <div className="orders-table-scroll">
            <table className="orders-table">
              <thead>
                <tr>
                  <th>Order name</th>
                  <th>Type</th>
                  <th>Buyer</th>
                  <th>Ordered date</th>
                  <th>Order status</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {[1, 2, 3, 4, 5].map((i) => (
                  <tr key={i} className="orders-table-row orders-table-row--skeleton">
                    <td colSpan={8}>
                      <div className="orders-skel-row">
                        <Skeleton width="28px" height="28px" style={{ borderRadius: '6px' }} />
                        <Skeleton width="40%" height="14px" />
                        <Skeleton width="90px" height="22px" style={{ borderRadius: '999px', marginLeft: 'auto' }} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="buyer-orders-container">
      <div className="buyer-orders-toolbar">
        <div className="buyer-orders-filters">
          <div className={`orders-filter-dropdown ${statusDropdownOpen ? 'active' : ''}`}>
            <button
              type="button"
              className="filter-dropdown-btn"
              onClick={() => {
                setStatusDropdownOpen(!statusDropdownOpen);
                setDateDropdownOpen(false);
              }}
            >
              {statusFilter === 'all' ? 'All statuses' : statusFilter === 'pending' ? 'Pending delivery' : 'Completed'}
              <ChevronDown size={14} />
            </button>
            <div className="filter-dropdown-menu">
              <button type="button" onClick={() => { setStatusFilter('all'); setStatusDropdownOpen(false); }}>All statuses</button>
              <button type="button" onClick={() => { setStatusFilter('pending'); setStatusDropdownOpen(false); }}>Pending delivery</button>
              <button type="button" onClick={() => { setStatusFilter('completed'); setStatusDropdownOpen(false); }}>Completed</button>
            </div>
          </div>
          <div className={`orders-filter-dropdown ${dateDropdownOpen ? 'active' : ''}`}>
            <button
              type="button"
              className="filter-dropdown-btn"
              onClick={() => {
                setDateDropdownOpen(!dateDropdownOpen);
                setStatusDropdownOpen(false);
              }}
            >
              {dateFilter === 'recent' ? 'Recent' : 'Oldest'}
              <ChevronDown size={14} />
            </button>
            <div className="filter-dropdown-menu">
              <button type="button" onClick={() => { setDateFilter('recent'); setDateDropdownOpen(false); }}>Recent</button>
              <button type="button" onClick={() => { setDateFilter('oldest'); setDateDropdownOpen(false); }}>Oldest</button>
            </div>
          </div>
        </div>
      </div>

      {paginatedOrders.length === 0 ? (
        <div className="buyer-orders-empty">
          <p>{t('dashboard.noOrdersFound', 'No orders found.')}</p>
        </div>
      ) : (
        <>
          <div className="orders-table-shell">
            <div className="orders-table-scroll">
              <table className="orders-table">
                <thead>
                  <tr>
                    <th
                      className={`sortable ${sortColumn === 'order_name' ? 'is-sorted' : ''}`}
                      onClick={() => handleSort('order_name')}
                    >
                      Order name
                      {sortColumn === 'order_name' && (
                        sortDirection === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />
                      )}
                    </th>
                    <th>Type</th>
                    <th>Buyer</th>
                    <th
                      className={`sortable ${sortColumn === 'ordered_date' ? 'is-sorted' : ''}`}
                      onClick={() => handleSort('ordered_date')}
                    >
                      Ordered date
                      {sortColumn === 'ordered_date' && (
                        sortDirection === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />
                      )}
                    </th>
                    <th>Order status</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedOrders.map((order) => {
                    const gameName = getGameName(order);
                    const gameIcon = getGameIcon(gameName);
                    const orderName = order.metadata?.ad_title || gameName || 'N/A';
                    const qty = order.metadata?.quantity || 1;
                    const currency = order.currency || 'USD';
                    const amount = parseFloat(order.amount || 0).toFixed(2);
                    const canDeliver = canMarkDelivered(order);
                    const isMarking = markingDelivered.has(order.id);

                    return (
                      <tr
                        key={order.id}
                        className="orders-table-row"
                        onMouseEnter={prefetchOrderDetail}
                        onClick={() => openOrder(order)}
                      >
                        <td>
                          <div className="order-name-cell">
                            <div className="order-game-icon-wrap">
                              {gameIcon ? (
                                <img src={gameIcon} alt="" className="order-game-icon" />
                              ) : (
                                <span className="order-game-icon-fallback">{(gameName || '?').charAt(0)}</span>
                              )}
                            </div>
                            <div className="order-name-text">
                              <span className="order-name-primary">{orderName}</span>
                              {orderName !== gameName && gameName !== 'N/A' ? (
                                <span className="order-name-secondary">{gameName}</span>
                              ) : null}
                            </div>
                          </div>
                        </td>
                        <td>{getOrderType(order)}</td>
                        <td>{order.buyer?.username || t('dashboard.unknown', 'Unknown')}</td>
                        <td className="order-date-cell">{formatDate(order.created_at)}</td>
                        <td>{getStatusBadge(order)}</td>
                        <td className="order-qty-cell">{qty}</td>
                        <td className="order-price-cell">{currency} {amount}</td>
                        <td onClick={(e) => e.stopPropagation()}>
                          {canDeliver ? (
                            <button
                              type="button"
                              className="btn-mark-delivered"
                              disabled={isMarking}
                              onClick={(e) => handleMarkDelivered(e, order.id)}
                            >
                              {isMarking ? t('dashboard.delivering', 'Delivering...') : t('dashboard.deliver', 'Deliver')}
                            </button>
                          ) : order.seller_marked_delivered ? (
                            <span className="order-item-action-note">{t('dashboard.completed', 'Completed')}</span>
                          ) : (
                            <span className="order-action-empty">—</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {totalPages > 1 && (
            <div className="buyer-orders-pagination">
              <button type="button" onClick={() => setCurrentPage(1)} disabled={currentPage === 1} className="pagination-btn">First</button>
              <button type="button" onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))} disabled={currentPage === 1} className="pagination-btn">
                <ChevronLeft size={16} />
              </button>
              <span className="pagination-page">{currentPage} / {totalPages}</span>
              <button type="button" onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))} disabled={currentPage === totalPages} className="pagination-btn">
                <ChevronRight size={16} />
              </button>
              <button type="button" onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} className="pagination-btn">Last</button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SellerOrders;
